/*
  Product card image swipe on phones.

  Cards that carry a second image (the desktop hover image) get a `card-swipe`
  class on their .media and a two-bar line indicator (see snippets/product-card
  .liquid). On screens up to 749px wide a horizontal swipe on the image slides
  between the two pictures and moves the indicator; desktop keeps the hover
  crossfade and never sees this. CSS lives in wick--component-card.css.

  Listeners are delegated to the document, so cards added by filtering or
  infinite scroll work without re-initialising anything. A swipe suppresses
  the card link's click for a moment so the shopper does not land on the
  product page by accident.
*/
(() => {
  if (window.__cardSwipeReady) return;
  window.__cardSwipeReady = true;

  const phone = window.matchMedia('(max-width: 749px)');
  const THRESHOLD = 24; // px of horizontal movement that counts as a swipe
  let touch = null;
  let lastSwipe = { media: null, at: 0 };

  const show = (media, second) => {
    media.classList.toggle('is-second', second);
    media.querySelectorAll('.card-swipe__dot').forEach((dot, index) => {
      dot.classList.toggle('is-active', index === (second ? 1 : 0));
    });
  };

  document.addEventListener(
    'touchstart',
    (event) => {
      if (!phone.matches) return;
      const media = event.target.closest('.media.card-swipe');
      if (!media || media.querySelectorAll('img').length < 2) return;
      const point = event.touches[0];
      touch = { media, x: point.clientX, y: point.clientY, done: false };
    },
    { passive: true }
  );

  document.addEventListener(
    'touchmove',
    (event) => {
      if (!touch || touch.done) return;
      const point = event.touches[0];
      const dx = point.clientX - touch.x;
      const dy = point.clientY - touch.y;
      if (Math.abs(dx) < THRESHOLD || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      touch.done = true;
      show(touch.media, dx < 0);
      lastSwipe = { media: touch.media, at: Date.now() };
    },
    { passive: true }
  );

  const reset = () => {
    touch = null;
  };
  document.addEventListener('touchend', reset, { passive: true });
  document.addEventListener('touchcancel', reset, { passive: true });

  document.addEventListener(
    'click',
    (event) => {
      const media = event.target.closest('.media.card-swipe');
      if (media && media === lastSwipe.media && Date.now() - lastSwipe.at < 500) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );
})();
